export let footerItems = [
  // { name: "ANDA © 2023" },
  // {
  //   name: "Conócenos",
  //   link: "https://www.andacol.com/index.php/anda/nosotros",
  // },
  // {
  //   name: "Nuestros afiliados",
  //   link: "https://www.andacol.com/index.php/afiliados",
  // },
  // {
  //   name: "Eventos",
  //   link: "https://www.andacol.com/index.php/anda/eventos-anda",
  // },

  {
    name: "Noticias",
    link: "https://inmov.com/blog/",
  },
  {
    name: "Terminos y condiciones",
    link: "https://inmov.com/terminos-y-condiciones/",
  },
];

export let footerSocialMediaItems = [
  { link: "", src: <i className="fa fa-twitter" aria-hidden="true"></i> },
  { link: "", src: <i className="fa fa-twitter" aria-hidden="true"></i> },
  { link: "", src: <i className="fa fa-twitter" aria-hidden="true"></i> },
];

export let homeHeroContent = {
  title: "Bienvenidos a nuestra plataforma tecnológica para afiliados",
  content: `Bienvenido a INMOVATION AI, tu asistente inteligente para vender mejor.
Accede fácilmente a 25 años de casos de éxito usando lenguaje natural.
¡Sigamos haciendo cosas increíbles!`,
};

export let LearnMoreContent = {
  content: (
    <>
      <div style={{ fontSize: "24px" }}>
        Bienvenido a INMOVATION AI, tu asistente inteligente para vender más y
        mejor.
      </div>
      <br /> <br />
      En esta plataforma podrás consultar fácilmente casos de éxito, proyectos
      destacados y toda la información histórica de nuestras ejecuciones usando
      lenguaje natural. Accede al conocimiento acumulado durante 25 años para
      construir el futuro de INMOV.
      <br /> <br />
      Explora ejemplos prácticos:
      <br />
      "Muéstrame casos de éxito en Trade Marketing"
      <br />
      "Proyectos destacados en transformación digital"
      <br />
      "Historial de convenciones durante los últimos tres años"
      <br /> <br />
      ¡Sigamos creando experiencias Phygital increíbles!
    </>
  ),
};

export let dashboardSideNavItems = [
  "Asociación Nacional de Anunciantes de Colombia",
  "Gobierno y estructura",

  "Formación",
  "Sostenibilidad",
  "Regulación y auto regulación",
  "Comunicaciones",
  "Federación Nacional de Anunciantes",
  "Entidades de gobierno",
];
export let dashboardIntroContent = `Nos enorgullece presentarte INMOVATION AI, la plataforma inteligente diseñada especialmente para ayudarte a destacar
y acelerar tus resultados comerciales.`;

export let dashboardIntroMiddleContent = `Con INMOVATION AI tienes acceso inmediato y sencillo a documentos históricos, actas, manuales, presentaciones,
infografías, propuestas y toda la información clave de INMOV y nuestros clientes, usando lenguaje natural o filtros
avanzados.`;

export let dashboardIntroLowerContent = `Esta plataforma refleja nuestra pasión por la innovación, integridad y excelencia, ofreciéndote herramientas precisas para
potenciar tu creatividad y fortalecer tu estrategia Phygital.
¡Sigamos impulsando juntos el futuro de INMOV!`;

export let noCategoryAndSubcategoryDialogueContent = `Para lograr resultados más rápidos y precisos, recomendamos seleccionar una
categoría y subcategoría. Si no está seguro, simplemente haga clic en el botón
"Continuar buscando". Tenga en cuenta que no elegir una
<b style='color:black'> categoría/subcategoría</b> conducirá a una búsqueda en la cual el tiempo de
respuesta será más larga ya que tiene que buscar en todas las
categorías/subcategorías antes de obtener resultados.`;
